var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg005Math(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.007,
    height: 48,
    viewBox: "0 0 48.007 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_005-math",
    "data-name": "005-math",
    transform: "translate(-1.994 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80181",
    "data-name": "Path 80181",
    d: "M45.219,13.483a2.4,2.4,0,0,0-3.354.461l0,0A23.64,23.64,0,0,1,24.64,22.6l-.05,0A23.661,23.661,0,0,1,7.349,14l-.031-.041a2.4,2.4,0,1,0-3.833,2.886l0-.007A28.147,28.147,0,0,0,24.544,27.4h.046A28.137,28.137,0,0,0,45.655,16.9l.043-.055a2.4,2.4,0,0,0-.473-3.354Z",
    transform: "translate(1.407 15.384)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(1.994 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80182",
    "data-name": "Path 80182",
    d: "M15.8,18.054V17.4a2.4,2.4,0,0,0-4.8,0v9.6a2.4,2.4,0,0,0,4.8,0Z",
    transform: "translate(10.604 16.184)",
    fill: "#3bbf83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80183",
    "data-name": "Path 80183",
    d: "M27.865,26.345,21.448,16.258a30.255,30.255,0,0,1-3.776,2.715l-.134.074,6.282,9.873a2.4,2.4,0,1,0,4.042-2.586l0,.01Z",
    transform: "translate(19.749 17.944)",
    fill: "#3bbf83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80184",
    "data-name": "Path 80184",
    d: "M8.8,16.278,2.385,26.367a2.374,2.374,0,0,0-.391,1.312,2.4,2.4,0,0,0,4.431,1.274l0-.01,6.282-9.873a30.479,30.479,0,0,1-3.956-2.828l.043.036Z",
    transform: "translate(-1.994 17.922)",
    fill: "#3bbf83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80185",
    "data-name": "Path 80185",
    d: "M35.088,32.1l-5.906-9.279a9.374,9.374,0,0,0,.916-4.073A9.507,9.507,0,0,0,22.9,9.53l-.065-.014a2.038,2.038,0,0,0,.062-.307l0-.012V4.4a2.4,2.4,0,0,0-4.8,0V9.2a2.242,2.242,0,0,0,.07.336l0-.017a9.508,9.508,0,0,0-6.318,13.366l-.024-.058L5.921,32.1A26.137,26.137,0,0,0,9.7,34.856l.118.065,5.244-8.242a9.553,9.553,0,0,0,10.927-.022l-.031.019L31.2,34.919a26.128,26.128,0,0,0,3.922-2.845l-.029.026Z",
    transform: "translate(3.499 -2)",
    fill: "#12784a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg005Math);
export default __webpack_public_path__ + "static/media/005-math.af8e03cd659c5af472ceb2ee5823c201.svg";
export { ForwardRef as ReactComponent };